module.exports = __webpack_public_path__ + "media/xp-waiting.617bb663.mp4";